export default class CheckoutApiDriveService {
  path = "/api/magasins";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Récupération du détail d'un checkout via son id
   * @param {Number} magId
   * @param {String} id
   */
  async checkout(magId, id) {
    const res = await this.httpApi.get(`${this.getPath(magId)}/${id}`);
    return res.data;
  }

  /**
   * Création d'un checkout pour un panier de référence
   * @param {Number} magId
   * @param {String} uuid
   * @param {String} dateLastUpdate
   */
  async create(magId, uuid, typePanier, dateLastUpdate) {
    const params = { uuid, dateLastUpdate, type_panier: typePanier };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}`, null, config);
    return res.data;
  }

  /**
   * Mise à jour d'un élément nécessaire du checkout: mode de retrait, mode de paiement
   * @param {Number} magId
   * @param {String} uuid
   * @param {String} dateLastUpdate
   */
  async update(magId, checkoutId, data) {
    const res = await this.httpApi.put(`${this.getPath(magId)}/${checkoutId}`, data);
    return res.data;
  }

  /**
   * Calcul des avantages d'un checkout
   * @param {Number} magId
   * @param {String} checkoutId
   * @param {String} dateLastUpdate
   */
  async processAvantages(magId, checkoutId, dateLastUpdate) {
    const params = { dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}/${checkoutId}/processAvantages`, null, config);
    return res.data;
  }

  /**
   * Validation d'un code promo
   * @param {Number} magId
   * @param {String} checkoutId
   * @param {String} dateLastUpdate
   * @param {String} codePromo
   */
  async processCodePromo(magId, checkoutId, dateLastUpdate, codePromo) {
    const params = { dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}/${checkoutId}/processCodePromo`, { code_promo: codePromo }, config);
    return res.data;
  }

  /**
   * Enregistrement d'un formulaire de redevance
   * @param {Number} magId
   * @param {String} checkoutId
   * @param {String} dateLastUpdate
   * @param {Object} formRedevance
   */
  async processFormRedevance(magId, checkoutId, dateLastUpdate, formRedevance) {
    const params = { dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}/${checkoutId}/processFormRedevance`, formRedevance, config);
    return res.data;
  }

  /**
   * Demande passage au paiement de la commande
   * @param {Number} magId
   * @param {String} checkoutId
   * @param {String} dateLastUpdate
   */
  async processPaiement(magId, checkoutId, dateLastUpdate) {
    const params = { dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}/${checkoutId}/processPaiement`, null, config);
    return res.data;
  }
  /**
   * Demande passage au paiement de la commande
   * @param {Number} magId
   * @param {String} checkoutId
   * @param {String} dateLastUpdate
   */
  async processPaiementCarteCadeau(magId, checkoutId, dateLastUpdate) {
    const params = { dateLastUpdate };
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.post(`${this.getPath(magId)}/${checkoutId}/processPaiementCarteCarrefour`, null, config);
    return res.data;
  }

  getPath(magId) {
    return `${this.path}/${magId}/checkout`;
  }
}
